<template>
  <v-content>
    <AppBar title="Användare" />
    <v-container fluid>
      <v-card>
        <v-data-table
          :footer-props="footerProps"
          :loading="$apollo.loading"
          :headers="headers"
          :items="definitions"
          :search="search"
          loading-text="Hämtar data..."
          no-data="Ingen data hittades..."
          no-results-text="Inget resultat på din sökning..."
          :height="tableHeight"
          :items-per-page="20"
          fixed-header
          sort-by="train_number_from"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Definitioner</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Sök..."
                single-line
                hide-details
                filled
                dense
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="showDefinitionCreateModal" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn tile color="primary" class="ml-2" dark v-on="on">
                    <v-icon small left>mdi-plus-circle</v-icon>
                    Skapa definition
                  </v-btn>
                </template>
                <DefinitionCreate
                  v-if="showDefinitionCreateModal"
                  @confirm="refetchUsers"
                  @close="showDefinitionCreateModal = false"
                />
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu left :close-on-click="true">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-dialog
                  :value="showDefinitionUpdateModal === item.id"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click="showDefinitionUpdateModal = item.id"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Redigera</v-list-item-title>
                    </v-list-item>
                  </template>
                  <DefinitionUpdate
                    :definition="item"
                    v-if="showDefinitionUpdateModal === item.id"
                    @confirm="refetchUsers"
                    @close="showDefinitionUpdateModal = null"
                  />
                </v-dialog>
                <v-dialog
                  :value="showDefinitionDeleteModal === item.id"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click="showDefinitionDeleteModal = item.id"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ta bort</v-list-item-title>
                    </v-list-item>
                  </template>
                  <DefinitionDelete
                    :definition="item"
                    v-if="showDefinitionDeleteModal === item.id"
                    @confirm="refetchUsers"
                    @close="showDefinitionDeleteModal = null"
                  />
                </v-dialog>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import DefinitionCreate from './DefinitionCreate'
import DefinitionDelete from './DefinitionDelete'
import DefinitionUpdate from './DefinitionUpdate'
import gql from 'graphql-tag'
import tableHeight from '@/mixins/tableHeight.js'

export default {
  name: 'Användare',

  mixins: [tableHeight],

  components: {
    AppBar,
    DefinitionCreate,
    DefinitionDelete,
    DefinitionUpdate
  },

  data: () => ({
    showDefinitionCreateModal: null,
    showDefinitionUpdateModal: null,
    showDefinitionDeleteModal: null,

    footerProps: {
      itemsPerPageOptions: [10, 20, 50],
      itemsPerPageText: 'Rader per sida'
    },
    search: '',
    headers: [
      {
        text: 'Tågnummer från',
        value: 'train_number_from'
      },
      {
        text: 'Tågnummer till',
        value: 'train_number_to'
      },
      {
        text: 'Typ',
        value: 'train_group'
      },
      {
        text: 'Definition',
        value: 'definition_text'
      },
      { text: '', value: 'actions', sortable: false, align: 'end' }
    ]
  }),

  apollo: {
    definitions: {
      fetchPolicy: 'cache-and-network',
      query: gql`
        query {
          definitions {
            id
            train_number_from
            train_number_to
            train_group
            definition_text
          }
        }
      `
    }
  },

  methods: {
    refetchUsers() {
      this.showDefinitionCreateModal = null
      this.showDefinitionUpdateModal = null
      this.showDefinitionDeleteModal = null
      this.showDefinitionCreateFromCsvModal = null
      this.$apollo.queries.definitions.refetch()
    }
  }
}
</script>
